import React from "react";
import { Redirect } from "react-router-dom";
import PageContainer from "../Components/UI/PageContainer";
import PageHeader from "../Components/UI/PageHeader";
import CalculatorForm from "./CalculatorForm";

export default function Calculator() {
  if (global.config.uid === "") return <Redirect to="/" />;

  return (
    <PageContainer maxWidth={900}>
      <PageHeader
        title="Salary Calculator"
        subtitle="Pick a date range to total your sessions and earnings per location"
      />
      <CalculatorForm />
    </PageContainer>
  );
}
